import { GetAppointments } from "../services/AppointmentsService";
import { GetMyCohorts } from "../services/cohortService";

export const handleAppointmentRequests = async () => {
  try {
    const requests = [GetAppointments(), GetMyCohorts()];
    const response = await Promise.all(requests);
    const appointmentData = response[0].data.data || [];
    const cohortsData = response[1].data.data || [];

    return {
      appointmentData,
      cohortsData,
    };
  } catch (error) {
    throw error;
  }
};

export const isMentor = (user) => {
  return user?.user_type === "instructor";
};
